<template>
  <div>
    <login-view v-if="numFactors === 1"></login-view>
    <login-view-2fa v-if="numFactors === 2"></login-view-2fa>
    <h3 v-if="numFactors !== 2 && numFactors !== 1">error: num auth factors not configured</h3>
  </div>

</template>

<script>
import LoginView from "@/client/views/Login.vue";
import LoginView2fa from "@/client/views/Login2Fa.vue";
export default {
  components: {LoginView, LoginView2fa},
  layout: {
    component: "boxy",
    params: { backgroundImage: false }, //"core/images/boxy/default-background.jpg"
  },
  props: {},
  data: function () {
    let numFactors = config.user.auth.numAuthenticationFactors;
    return {
      numFactors,
      traceExpanded: false,
    };
  },
  computed: {
    logoStyle() {
      if (!this.logoSrc) {
        return {};
      }

      let url = utilities.requireAsset(this.logoSrc);
      return {
        backgroundImage: "url('" + url + "')",
        "background-size": "contain",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        height: "80px",
        width: "100%",
      };
    },
  },
  meta: "core.loginPage.pageTitle",
};
</script>

<style scoped lang="scss"></style>
